<template>
  <v-container>
    <v-app-bar app dark dense v-show="$vuetify.breakpoint.mdAndDown">
      <v-img id="logo" alt="Anewo" class="shrink mt-1" contain :src="logoUrl" />

      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="navdrawer = true" right></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      app
      :permanent="!$vuetify.breakpoint.mdAndDown"
      class="grey darken-4 text--white"
      dark
      :fixed="true"
      v-model="navdrawer"
    >
      <v-layout justify-space-between column fill-height>
        <v-container>
          <v-list-item class="px-4">
            <v-list-item-title
              >{{ User.firstname }} {{ User.lastname }}</v-list-item-title
            >

            <v-btn icon @click="logout" class="pa-2">
              <v-icon color="red lighten-1">mdi-logout</v-icon>
            </v-btn>
          </v-list-item>

          <v-list dense nav>
            <v-list-item link to="/dashboard">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/customers"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-box-multiple</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Kunden</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/meals"
            >
              <v-list-item-icon>
                <v-icon>mdi-food-turkey</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Speisen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/mealcategories"
            >
              <v-list-item-icon>
                <v-icon>mdi-select-group</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Speisekategorien</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.CustomerAdmin
                  )
              "
              link
              to="/orders"
            >
              <v-list-item-icon>
                <v-icon>mdi-basket</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Bestellungen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/notifications"
            >
              <v-list-item-icon>
                <v-icon>mdi-bell-ring</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Benachrichtigungen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/user"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-supervisor</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Benutzer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              link
              to="/robots"
            >
              <v-list-item-icon>
                <v-icon>mdi-robot-industrial</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Roboter</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.SuperUser
                ) ||
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.Manager
                  )
              "
              :value="false"
              prepend-icon="mdi-cog"
            >
              <template v-slot:activator>
                <v-list-item-title>Einstellungen</v-list-item-title>
              </template>
              <v-list-item
                v-if="
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.SuperUser
                  ) ||
                    this.checkAccess(
                      this.$store.getters['user/userRoles'].userRole.Manager
                    )
                "
                link
                to="/settings/mail"
              >
                <v-list-item-content>
                  <v-list-item-title>Email-Versand</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item
                v-if="
                  this.checkAccess(
                    this.$store.getters['user/userRoles'].userRole.SuperUser
                  ) ||
                    this.checkAccess(
                      this.$store.getters['user/userRoles'].userRole.Manager
                    )
                "
                link
                to="/settings/mailtemplates"
              >
                <v-list-item-content>
                  <v-list-item-title>Email Vorlagen</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>mdi-file-document</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.CustomerAdmin
                )
              "
              link
              to="/customer/settings"
            >
              <v-list-item-icon>
                <v-icon>mdi-office-building</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Firmeninfos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.CustomerAdmin
                )
              "
              link
              to="/customer/departments"
            >
              <v-list-item-icon>
                <v-icon>mdi-folder-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Abteilungen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                checkAccess(
                  this.$store.getters['user/userRoles'].userRole.CustomerAdmin
                ) &&
                  Customer &&
                  Customer.manageLieferorte
              "
              link
              to="/customer/locations"
            >
              <v-list-item-icon>
                <v-icon>mdi-truck-delivery</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Lieferorte</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                this.checkAccess(
                  this.$store.getters['user/userRoles'].userRole.CustomerAdmin
                )
              "
              link
              to="/mitarbeiter"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Mitarbeiter</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-container>
        <v-container justify-end>
          <v-layout justify-center align-center column>
            <span style="color: #ccc; font-size: 10px">{{ appVersion }}</span>
          </v-layout>
        </v-container>
      </v-layout>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "Navigation",
  components: {},
  props: ["user", "label", "linktext", "linkurl"],

  data: () => ({
    navdrawer: null,
    settingsMenu: null,
  }),
  methods: {
    logout() {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push("/");
        this.$notify({
          group: "dataline",
          type: "info",
          title: "Logout",
          text: "Sie sind jetzt abgemeldet.",
        });
      });
    },
    checkAccess(role) {
      const user = this.User;

      if (!user) {
        return false;
      }
      if (user.role === role) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    logoUrl() {
      return `${process.env.VUE_APP_API_URL}/ressources/images/logo.png`;
    },
    appVersion() {
      return this.$store.getters.appVersion;
    },
    User() {
      return this.$store.getters["user/getUser"];
    },
    Customer() {
      return this.$store.getters["customer/getCurrent"];
    },
  },

  created() {
    if (!this.User.customerId === "system") {
      this.$store
        .dispatch("customer/fetchCustomer", this.User.customerId)
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style scoped>
nav li:hover,
nav li.router-link-active,
nav li.router-link-exact-active {
  background-color: indianred;
  cursor: pointer;
}

#logo {
  display: inline-block;
  min-width: 100px;
  max-height: 35px;
  width: 150px;
}

#datafieberlink {
  vertical-align: middle;
}

hr {
  margin: 10px 0px;
}
</style>
